import { Tag, CaretRight } from '@phosphor-icons/react'
import { Icon, Input } from '@shopflo/ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface CouponType {
  type: 'cards' | 'codeEntry'
}

const PreviewCoupons: React.FC<CouponType> = ({ type }) => {
  const { t } = useTranslation()
  const renderCardsCoupons = () => {
    return (
      <div
        className='relative flex h-[4.5rem] w-full flex-row space-x-1 items-center justify-between rounded-2xl bg-white cursor-pointer overflow-hidden border-1'
        id='flo_coupons_applied'
      >
        <div
          className='absolute left-0 top-0 h-full w-full animate-slide
    bg-gradient-to-l from-[#2b874a03] from-0% via-[#2c874a12] via-[#2c874a12] via-[#2c874a21] via-[#2c874a21] via-20% via-40% via-60% via-80% to-[#2c874a03] to-100% !bg-[length:30%_100%] !bg-no-repeat'
        ></div>
        <div className='w-full flex space-x-1 py-3 pl-3'>
          <div className='flex justify-start h-full text-yay-dark items-start py-0.5'>
            <Icon IconComponent={Tag} size='sm' className='h-4 min-h-4 w-4 min-w-4' />
          </div>
          <div className='flex flex-col h-full space-y-[3px] justify-start items-start w-full'>
            <p className='text-sm font-medium text-yay-dark'>{t('payments_tab.coupons_save_text')}</p>
            <p className='pl-1 text-xs font-medium text-coal-dark'>{t('payments_tab.coupons_with_code')}</p>
            <div className='pl-1 text-xs text-coal-dark font-medium flex items-center cursor-pointer'>
              <span>{t('payments_tab.coupons_view_other')}</span>
              <Icon IconComponent={CaretRight} size='xs' className='w-3 h-3' />
            </div>
          </div>
        </div>
        <div className='flex justify-start py-3 pr-3 items-start h-full w-[4.5rem]'>
          <span className='text-xs font-medium text-yay-dark cursor-pointer rounded-lg px-3 py-2 border-1 border-yay-dark bg-yay-lighter'>
            {t('payments_tab.apply')}
          </span>
        </div>
      </div>
    )
  }

  const renderCodeEntryCoupons = () => {
    return (
      <div className='4'>
        <Input startAdornment={<Tag size={16} />} />
      </div>
    )
  }

  return (
    <div className='flex flex-col gap-2 py-2 px-4'>
      <h2 className='text-text-xs-medium text-coal-light '>{t('payments_tab.coupons_title')}</h2>
      {type === 'cards' ? renderCardsCoupons() : renderCodeEntryCoupons()}
    </div>
  )
}

export default PreviewCoupons
